import { ColorsEnum } from "../../core/et3-theme/colors";

const ALPHA_NONE = "00";
const ALPHA_FAINT = "0F";
const ALPHA_TINT = "1F";
const ALPHA_RING = "2E";
const ALPHA_GLOW = "42";
const ALPHA_GLOW_STRONG = "57";
const ALPHA_BACKDROP = "66";

export const LOGIN_SCREEN_WIDTH = 1920;
export const LOGIN_SCREEN_HEIGHT = 1080;

export const LOGIN_BRAND_PANEL_WIDTH = 760;
export const LOGIN_FORM_PANEL_WIDTH = 1160;

export const LOGIN_BREAKPOINT_NARROW = 1000;
export const LOGIN_BREAKPOINT_WIDE = 1600;
export const LOGIN_BRAND_SHARE_NARROW = 0.26;
export const LOGIN_BRAND_SHARE_WIDE = 0.4;
export const LOGIN_BRAND_PANEL_PADDING_RATIO = 0.105;

export const LOGIN_TEXT_MIN_FONT_PX = 12;
export const LOGIN_INPUT_MIN_FONT_PX = 14;
export const LOGIN_HEADING_MIN_FONT_PX = 20;

export const LOGIN_FULL_WIDTH_CSS = "100%";
export const LOGIN_FULL_HEIGHT_CSS = "100vh";
export const LOGIN_NO_MINIMUM_CSS = 0;

export const LOGIN_FORM_COLUMN_MAX_WIDTH_CSS = "440px";
export const LOGIN_FORM_PANEL_GUTTER_CSS = "clamp(16px, 3vw, 60px)";
export const LOGIN_FORM_GAP_CSS = "clamp(10px, 2.1vh, 22px)";
export const LOGIN_FORM_HEADING_GAP_CSS = "clamp(6px, 1vh, 10px)";

export const LOGIN_FIELD_HEIGHT_CSS = "clamp(44px, 5.2vh, 56px)";
export const LOGIN_FIELD_RADIUS_CSS = "clamp(10px, 1vw, 14px)";
export const LOGIN_FIELD_PADDING_X_CSS = "clamp(12px, 1.1vw, 20px)";
export const LOGIN_FIELD_GAP_CSS = "clamp(10px, 0.8vw, 14px)";
export const LOGIN_FIELD_ICON_SIZE_CSS = "clamp(14px, 1.6vmin, 18px)";
export const LOGIN_FIELD_LABEL_GAP_CSS = "clamp(4px, 0.8vh, 8px)";

export const LOGIN_FIELD_INPUT_CLASS = "login-field-input";
export const LOGIN_ALERT_HEIGHT_CSS = "clamp(38px, 4.3vh, 46px)";
export const LOGIN_ALERT_RADIUS_CSS = "clamp(8px, 0.9vw, 12px)";
export const LOGIN_ALERT_PADDING_X_CSS = "clamp(10px, 0.9vw, 16px)";
export const LOGIN_ALERT_GAP_CSS = "clamp(8px, 0.7vw, 12px)";

export const LOGIN_BUTTON_HEIGHT_CSS = "clamp(44px, 5.2vh, 56px)";
export const LOGIN_BUTTON_RADIUS_CSS = "clamp(10px, 1vw, 14px)";

export const LOGIN_BRAND_PADDING_X_CSS = "clamp(20px, 3.2vw, 80px)";
export const LOGIN_BRAND_PADDING_Y_CSS = "clamp(24px, 5vh, 76px)";
export const LOGIN_BRAND_LOGO_WIDTH_CSS = "clamp(110px, 13vw, 230px)";
export const LOGIN_BRAND_TEXT_GAP_CSS = "clamp(8px, 1.7vh, 18px)";

export const LOGIN_BRAND_PANEL_PADDING_X = 80;
export const LOGIN_BRAND_PANEL_PADDING_Y = 76;
export const LOGIN_BRAND_LOGO_SIZE = 230;
export const LOGIN_BRAND_TEXT_BLOCK_WIDTH = 600;
export const LOGIN_BRAND_TEXT_GAP = 18;
export const LOGIN_BRAND_HEADLINE_FONT_SIZE = 46;
export const LOGIN_BRAND_TAGLINE_FONT_SIZE = 22;
export const LOGIN_BRAND_TAGLINE_LINE_HEIGHT = 1.5;
export const LOGIN_BRAND_FOOTNOTE_FONT_SIZE = 14;
export const LOGIN_BRAND_TAGLINE_OPACITY = 0.72;
export const LOGIN_BRAND_FOOTNOTE_OPACITY = 0.55;

export const LOGIN_FORM_COLUMN_WIDTH = 440;
export const LOGIN_FORM_GAP = 22;
export const LOGIN_FORM_HEADING_GAP = 10;
export const LOGIN_FORM_HEADING_FONT_SIZE = 40;
export const LOGIN_FORM_SUBTITLE_FONT_SIZE = 19;

export const LOGIN_FIELD_HEIGHT = 56;
export const LOGIN_FIELD_RADIUS = 14;
export const LOGIN_FIELD_PADDING_X = 20;
export const LOGIN_FIELD_ICON_GAP = 14;
export const LOGIN_FIELD_ICON_SIZE = 17;
export const LOGIN_FIELD_LABEL_GAP = 8;
export const LOGIN_FIELD_LABEL_FONT_SIZE = 14;
export const LOGIN_FIELD_INPUT_FONT_SIZE = 17;
export const LOGIN_FIELD_HINT_FONT_SIZE = 13;
export const LOGIN_FIELD_BORDER = "1px solid";
export const LOGIN_ALERT_BACKGROUND = `${ColorsEnum.red}${ALPHA_TINT}`;
export const LOGIN_ALERT_BORDER = `${LOGIN_FIELD_BORDER} ${ColorsEnum.red}${ALPHA_RING}`;
export const LOGIN_FIELD_SHADOW = `0 1px 2px ${ColorsEnum.maastrichtBlue}${ALPHA_FAINT}`;
export const LOGIN_FIELD_FOCUS_SHADOW = `0 0 0 4px ${ColorsEnum.bondiBlue}${ALPHA_RING}, ${LOGIN_FIELD_SHADOW}`;
export const LOGIN_FIELD_ERROR_SHADOW = `0 0 0 4px ${ColorsEnum.red}${ALPHA_RING}, ${LOGIN_FIELD_SHADOW}`;

export const LOGIN_ALERT_HEIGHT = 46;
export const LOGIN_ALERT_RADIUS = 12;
export const LOGIN_ALERT_PADDING_X = 16;
export const LOGIN_ALERT_GAP = 12;
export const LOGIN_ALERT_FONT_SIZE = 15;
export const LOGIN_ALERT_ICON_SIZE = 16;

export const LOGIN_BUTTON_HEIGHT = 56;
export const LOGIN_BUTTON_RADIUS = 14;
export const LOGIN_BUTTON_FONT_SIZE = 19;
export const LOGIN_BUTTON_SHADOW = `0 6px 16px ${ColorsEnum.bondiBlue}${ALPHA_GLOW}`;
export const LOGIN_BUTTON_HOVER_SHADOW = `0 10px 24px ${ColorsEnum.bondiBlue}${ALPHA_GLOW_STRONG}`;
export const LOGIN_BUTTON_DISABLED_SHADOW = "none";
export const LOGIN_BUTTON_PRESS_OFFSET = 1;

export const LOGIN_BRAND_BACKDROP = `radial-gradient(circle at 18% 12%, ${ColorsEnum.bondiBlue}${ALPHA_BACKDROP} 0%, ${ColorsEnum.bondiBlue}${ALPHA_NONE} 46%), radial-gradient(circle at 86% 84%, ${ColorsEnum.shadeOfBlueDark}${ALPHA_GLOW_STRONG} 0%, ${ColorsEnum.shadeOfBlueDark}${ALPHA_NONE} 52%)`;
export const LOGIN_LOGO_MONOCHROME_FILTER = "brightness(0) invert(1)";
export const LOGIN_TRANSITION =
  "box-shadow 160ms cubic-bezier(0.4, 0, 0.2, 1), border-color 160ms cubic-bezier(0.4, 0, 0.2, 1), background-color 160ms cubic-bezier(0.4, 0, 0.2, 1), transform 160ms cubic-bezier(0.4, 0, 0.2, 1), opacity 160ms cubic-bezier(0.4, 0, 0.2, 1)";
